import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'theme/withStyles';
import classnames from 'classnames';
import RawHtml from 'common/RawHtml';
import buttonLinkStyles from 'styles/buttonLink';

const styles = (theme) => ({
  appList: {
    listStyle: 'none',
    margin: 0,
    padding: [0, theme.spacing.xs + theme.spacing.unit],
    width: '100%',
  },
  appListItem: {
    display: 'flex',
    fontSize: 18,
    padding: [10, 0],
  },
  continue: {
    ...buttonLinkStyles(theme),
    '& i:before': {
      content: '"\u2192"',
    },
    '&:hover': {
      color: theme.oaoButtons.primary.color,
      textDecoration: 'underline',
    },
    color: theme.oaoButtons.primary.color,
    float: 'right',
    textDecoration: 'none',
  },
  header: {
    '& h1': {
      ...theme.typography.h2,
      color: theme.oaoButtons.primary.color,
      marginBottom: 0,
    },
    alignItems: 'center',
    background: theme.oaoButtons.primary.background,
    display: 'flex',
    fontSize: 16,
    fontWeight: 400,
    justifyContent: 'space-between',
    marginBottom: theme.spacing.xs,
    padding: [theme.spacing.unit * 2, theme.spacing.xs + theme.spacing.unit],
  },
  name: {
    ...theme.typography.h2,
    '& span': {
      ...theme.typography.p,
      ...theme.typography.p1,
      [`@media(min-width: ${theme.screenSizes.mobileMax}px)`]: {
        fontSize: theme.typography.p1.desktopFontSize,
      },
    },
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    fontWeight: 700,
  },
  status: {
    ...theme.typography.p,
    ...theme.typography.p1,
    [`@media(min-width: ${theme.screenSizes.mobileMax}px)`]: {
      fontSize: theme.typography.p1.desktopFontSize,
    },
    flex: 1,
    textAlign: 'right',
    ...theme.custom.home.status,
  },
});

export const HomeAppRequestHeaderBare = ({
  classes,
  disableButton,
  request,
  resources,
  restart,
}) => {
  function handleContinue(e) {
    e.preventDefault();
    if (!disableButton) {
      restart({
        appRequestId: request.id,
      });
    }
  }

  return (
    <>
      <div className={classnames('header', classes.header)}>
        <RawHtml type="h1">{request.startedLabel}</RawHtml>
        {request.continue ? (
          /* eslint-disable-next-line jsx-a11y/anchor-is-valid */
          <button
            type="button"
            className={classnames('buttonLink continue', classes.continue, {
              disabled: disableButton,
            })}
            onClick={handleContinue}
          >
            <RawHtml type="span">{request.continueLinkLabel}</RawHtml>{' '}
            <i className="icon-arrow-thin-right" aria-hidden="true" />
          </button>
        ) : (
          <span className="continue-nolink">
            <RawHtml>{request.continueLinkLabel}</RawHtml>
          </span>
        )}
      </div>
      <ul className={classes.appList}>
        {request.apps.map((app) => (
          <li
            key={app.id}
            data-name={app.name}
            data-id={app.id}
            data-status={app.metaStatus}
            className={classes.appListItem}
          >
            <div className={classnames('name', classes.name)}>
              <RawHtml type="div">{app.label}</RawHtml>
              {app.accountNumber && resources.accountNumberLabel && (
                <span className="account-number">
                  {resources.accountNumberLabel}
                  {': '}
                  <RawHtml type="span">{app.accountNumber}</RawHtml>
                </span>
              )}
              {app.routingNumber && resources.routingNumberLabel && (
                <span className="routing-number">
                  {resources.routingNumberLabel}
                  {': '}
                  <RawHtml type="span">{app.routingNumber}</RawHtml>
                </span>
              )}
              {app.memberNumber && resources.memberNumberLabel && (
                <span className="member-number">
                  {resources.memberNumberLabel}
                  {': '}
                  <RawHtml type="span">{app.memberNumber}</RawHtml>
                </span>
              )}
            </div>
            <RawHtml type="div" className={classnames('status', classes.status)}>
              {app.metaStatus}
            </RawHtml>
          </li>
        ))}
      </ul>
    </>
  );
};

HomeAppRequestHeaderBare.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  disableButton: PropTypes.bool.isRequired,
  request: PropTypes.shape({
    apps: PropTypes.arrayOf(PropTypes.shape({})),
    continue: PropTypes.bool,
    continueLinkLabel: PropTypes.string,
    id: PropTypes.number,
    startedLabel: PropTypes.string,
  }).isRequired,
  resources: PropTypes.shape({
    accountNumberLabel: PropTypes.string,
    memberNumberLabel: PropTypes.string,
    routingNumberLabel: PropTypes.string,
  }).isRequired,
  restart: PropTypes.func.isRequired,
};

const HomeAppRequestHeaderStyled = withStyles(styles)(HomeAppRequestHeaderBare);

export default HomeAppRequestHeaderStyled;
